<app-option-bar [type]="'GOPHER'"></app-option-bar>
<div class="gopher-wrapper">
  <div class="container-fluid">
    <div class="content-wrapper">
      <!-- Menu Section -->
      <div class="inner-nav">
        <app-left-menu [type]="'GOPHER'"></app-left-menu>
      </div>

      <div class="inner-content collapsed">
        <div class="common-section">
          <div class="common-heading">
            Attack details
            <button *ngIf="!attackDetails?.isCompleted" style="margin-top: -8px"
              class="btn btn-sm btn-danger float-right" (click)="haltAttack(attackDetails.id)">
              Halt attack
            </button>
          </div>
          <div class="common-box">
            <h4 class="font-bold">Configuration</h4>
            <hr />
            <div class="row">
              <div class="col">
                <label class="font-bold">Type : </label>
                {{ attackDetails?.type }}
              </div>
              <div class="col" *ngFor="let item of attackDetails.args | keyvalue">
                <label class="font-bold text-capitalize">{{ item.key }} : </label> {{ item.value }}
              </div>
            </div>
            <h4 class="font-bold mt-3">Details</h4>
            <hr />
            <div class="row">
              <div class="col">
                <label class="font-bold">Status : </label>
                <span [ngClass]="{ 'text-success': attackDetails.status === 'COMPLETED' }"> {{ attackDetails?.status
                  }}</span>
                <img src="/assets/images/spin.svg" alt="Loading .." width="18px" *ngIf="!attackDetails.isCompleted" />
              </div>
              <div class="col">
                <label class="font-bold">User : </label>
                {{ attackDetails.attackedBy?.displayName }}
              </div>
              <div class="col">
                <label class="font-bold">Kind : </label>
                {{ attackDetails.gopherClient?.server_type }}
              </div>
              <div class="col">
                <label class="font-bold">Start : </label>
                {{ attackDetails?.startTime | localDate }}
              </div>
              <div class="col">
                <label class="font-bold">End : </label>
                {{ attackDetails?.endTime | localDate }}
              </div>
            </div>
            <h4 class="font-bold relay-margin-top-30">Executions</h4>
            <hr />
            <div class="row">
              <div class="col-8">
                <canvas id="trendChart" ngChartjs [data]="data" [labels]="labels" [chartType]="lineChartType"
                  [options]="lineChartOptions" [legend]="false" [colors]="colors"></canvas>
              </div>
              <div class="col-4" *ngIf="attackDetails?.results">
                <div class="output-sec">
                  <p *ngFor="let result of attackDetails?.results">
                    {{ result.usage }} <small>(Usage)</small> from {{ result.startTime }} - {{ result.endTime }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>